export const TOGGLE_USER_RESEARCH_CHOICE = 'TOGGLE_USER_RESEARCH_CHOICE'

export function displayUserResearchChoiceReducer(state = false, action) {
    switch (action.type){
        case TOGGLE_USER_RESEARCH_CHOICE:
            return action.payload
        default: return state
    }
}